import { LinkType } from "core/codegen/types";
import { config } from "core/utils";
import { Tracking } from "core/tracking";
export function getProgramVariant(item) {
    return item.linkType === LinkType.VtmGo
        ? config.tracking.vtmGo.program
        : undefined;
}
export function getCategory(linkType) {
    switch (linkType) {
        case "program":
        case "vtmGo":
            return config.tracking.linkType.program;
        case "tvGuide":
            return config.tracking.linkType.tvGuide;
        default:
            return linkType;
    }
}
export function trackTopPicks(typename, items) {
    var impressions = items.map(function (item, index) {
        var _a;
        return ({
            list: typename,
            id: (_a = item.program) !== null && _a !== void 0 ? _a : item.uuid,
            name: item.title,
            category: getCategory(item.linkType),
            position: index + 1,
            variant: item.liveUrl
                ? config.tracking.vtmGo.live
                : getProgramVariant(item),
        });
    });
    Tracking.trackProductImpression(impressions);
}
